import React from 'react';

export default function StatusBadge({ status }) {
  return <span className={`badge badge-${status?.replace(' ', '-')}`}>{status}</span>;
}
